/*eslint-disable @typescript-eslint/restrict-plus-operands */
import { Dispatch, FC, SetStateAction, useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";
import MuteIcon from "@ht/shared/fonts/deos-pis/mic-mute";
import UnmuteIcon from "@ht/shared/fonts/deos-pis/mic";
import ChatIcon from "@ht/shared/fonts/deos-pis/chat";
import HangupIcon from "@ht/shared/fonts/deos-pis/call-hangup";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { vCallIncomingMessageReceived, vCallSendMessage, vCallStateChanged } from "../../../../app/videocall/videoSlice";
import { setOverlay } from "../../../../app/layout/layoutStateSlice";
import { useDragging } from "../../../../hooks/useDragging";
import AudioCard from "../Cards/AudioCard";
import { useNavigate, useParams } from "react-router-dom";
import { AntmediaContext } from "../../../../App";
import { SettingsContext, MediaSettingsContext } from "../../DMSMedia";
import { readMessage, activeChatRoom } from "../../../../app/chat/chatSlice";
import { setOnCall } from "../../../../app/userState/userStateSlice";
import { decodeRouteParam, encodeRouteParam } from "../../../../utils/routeParam";
import { IVCallIncomingMessage, IVCallState } from "../../../../app/videocall/types";

type LocalData = {
    streamId: string,
}
interface IProps {
    participants: any[];
    allParticipants: any[];
    myLocalData: LocalData | undefined;
    roomName: string;
}
const LoadLocalVideo = (participants: any[], pinRemoteVideo: any, setPinRemoteVideo: Dispatch<SetStateAction<boolean>>, setPinVideoId: Dispatch<SetStateAction<string>>, pinVideoId: string) => {
    return (
        <div key="localvideo"
            className={clsx("w-[140px]")}

        >
            <div className={clsx(pinRemoteVideo && "rounded-lg shadow-sm", "bg-black h-[100%]")}>
                <AudioCard
                    onHandlePin={() => {
                        setPinRemoteVideo(false)
                        setPinVideoId("localVideo")
                    }}
                    id="localVideo"
                    autoPlay
                    name="You"
                    muted
                    hidePin={participants.length === 0}
                    pinned={pinVideoId === "localVideo" || pinVideoId === ""}

                />
            </div>
        </div>
    )
}
const LoadParticipants = (participants: any[], setPinRemoteVideo: Dispatch<SetStateAction<boolean>>, setPinVideoId: Dispatch<SetStateAction<string>>, pinVideoId: string) => {
    return (
        <div
            key="UNPINNEDREMOTEVIDEO"
            className={clsx("flex flex-col gap-[10px] w-[120px]"
            )}
        >
            {participants
                .map(({ id, track, name }, index) => {
                    const key = `key${index}`
                    return (
                        <div
                            className={clsx("w-[120px] h-[100%]")}
                            key={key}
                        >
                            <AudioCard
                                onHandlePin={() => {
                                    setPinRemoteVideo(true)
                                    setPinVideoId(id)
                                }}
                                id={id}
                                track={track}
                                autoPlay
                                name={name}
                                pinned={pinVideoId === id}

                            />
                        </div>
                    )
                }
                )}
        </div>
    )
}
const AudioCallControl: FC<IProps> = ({ participants, allParticipants, myLocalData, roomName }) => {
    const dispatch = useAppDispatch();
    //--------------------------------------------
    const antmedia = useContext(AntmediaContext);
    const msettings = useContext(MediaSettingsContext);


    const settings = useContext(SettingsContext);
    const { drawerOpen, pinnedVideoId, audioTracks } =
        settings;


    const [pinRemoteVideo, setPinRemoteVideo] = useState(true)
    const [pinVideoId, setPinVideoId] = useState("")


    useEffect(() => {
        const localVid = document.getElementById("localVideo");
        if (localVid && antmedia.mediaManager) {
            antmedia.mediaManager.localVideo = document.getElementById("localVideo");
            if (antmedia.mediaManager.localVideo)
                (antmedia.mediaManager.localVideo as HTMLVideoElement).srcObject =
                    antmedia.mediaManager.localStream;
        }
    }, [pinnedVideoId]);


    useEffect(() => {
        console.log("list participants", participants)
        if (!pinVideoId)
            setPinVideoId("localVideo")

    }, [participants, pinnedVideoId]);

    useEffect(() => {
    }, [drawerOpen]);



    const { user } = useAppSelector((state) => state.auth);
    const { vCallIncomingMessage, vCallState } = useAppSelector((state) => state.vcall);

    const { incomingRoom, activeRoom } = useAppSelector((state) => state.chat);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);

    const [duration, setDuration] = useState(vCallState.duration > 0 ? vCallState.duration : 0);
    const [intervalId, setIntervalId] = useState(0);
    const [joinedRoom] = useState(false);
    const callnotifWidth = 520;
    const locationX = floatingLocation.x === 0 ? screen.width - callnotifWidth - floatingLocation.x - 10 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 66 : floatingLocation.y
    const { ref, x, y, isDragging } = useDragging(locationX, locationY, 400, 104);

    const { chatId } = useParams();
    const [rightPanel] = useState("profile");
    const [roomId, setRoomId] = useState("");

    const navigate = useNavigate();

    const requestStream = () => {
        if (!user)
            return;
        const payload = {
            content:
                JSON.stringify({
                    callid: vCallState.CallId,
                    sessionid: vCallState.SessionId,
                    requesttype: "RequestStream",
                    deviceid: vCallIncomingMessage.deviceid,
                    username: vCallIncomingMessage.username,
                    subscriptionid: process.env.REACT_APP_SUBSCRIPTIONID,
                    destdeviceid: "agentStream" + user.deviceId,
                    destusername: user.username,
                    type: "agent",
                    tag: "generic",
                    channel: vCallIncomingMessage.channel,
                    calltype: vCallIncomingMessage.calltype
                })
        }

        dispatch(vCallSendMessage(payload));
    }
    useEffect(() => {
        requestStream()
    }, [])
    const changeRoom = () => {
        if (roomId) {
            const currentActiveRoom = incomingRoom.find(z => z.roomId === roomId)
            if (currentActiveRoom) {
                dispatch(activeChatRoom(currentActiveRoom))
            }

            dispatch(readMessage({ sessionId: currentActiveRoom?.sessionId, messageId: 0 }));

        }
    }
    useEffect(() => {
        if (incomingRoom.length > 0 && activeRoom !== undefined) {
            changeRoom();
        }
    }, [incomingRoom, activeRoom]);
    useEffect(() => {
        if (chatId)
            setRoomId(decodeRouteParam(chatId));
    }, [chatId]);
    let timer: number;
    const startTimer = () => {
        if (intervalId !== undefined) {
            timer = window.setInterval(() => {
                setDuration(dur => dur + 1);

            }, 1000);
            setIntervalId(timer);
        }
    };
    const stopTimer = () => {
        window.clearInterval(intervalId);
    }
    const toHHMMSS = (dur: number) => {
        const hours = Math.floor(dur / 3600);
        const minutes = Math.floor((dur - (hours * 3600)) / 60);
        const seconds = dur - (hours * 3600) - (minutes * 60);
        let strhours = hours.toString();
        let strminutes = minutes.toString();
        let strseconds = seconds.toString();

        if (hours < 10) { strhours = "0" + hours.toString(); }
        if (minutes < 10) { strminutes = "0" + minutes.toString(); }
        if (seconds < 10) { strseconds = "0" + seconds.toString(); }
        return strhours + ':' + strminutes + ':' + strseconds;
    }

    const mic = msettings?.mic?.find((m: { eventStreamId: string; }) => m.eventStreamId === 'localVideo');



    const cameraOff = () => {
        if (!msettings.isScreenShared) {
            msettings?.toggleSetCam({
                eventStreamId: "localVideo",
                isCameraOn: false,
            });
            if (myLocalData?.streamId) {
                antmedia.turnOffLocalCamera(myLocalData.streamId);
                antmedia.handleSendNotificationEvent(
                    "CAM_TURNED_OFF",
                    myLocalData.streamId
                );
            } else {
                antmedia.turnOffLocalCamera("localVideo");
            }
        }
    }

    const muteMic = () => {
        msettings?.toggleSetMic({
            eventStreamId: 'localVideo',
            isMicMuted: true,
        });
        antmedia.muteLocalMic();
        if (msettings?.myLocalData?.streamId) {
            antmedia.handleSendNotificationEvent('MIC_MUTED', msettings?.myLocalData?.streamId);
            antmedia.updateAudioLevel(msettings?.myLocalData?.streamId, 0);
        }
    }
    const unmuteMic = () => {
        msettings?.toggleSetMic({
            eventStreamId: 'localVideo',
            isMicMuted: false,
        });
        antmedia.unmuteLocalMic();
        if (msettings?.myLocalData?.streamId) {
            antmedia.handleSendNotificationEvent('MIC_UNMUTED', msettings?.myLocalData?.streamId);

        }
    }


    const toggleMute = () => {
        if (mic?.isMicMuted)
            unmuteMic();
        else
            muteMic();
    }

    const resetIncomingCall = () => {
        dispatch(vCallIncomingMessageReceived({} as IVCallIncomingMessage));
        dispatch(vCallStateChanged({} as IVCallState));

    }
    const hangupVideoCall = () => {
        stopTimer()
        cameraOff();
        dispatch(setOnCall(""));
        if (antmedia.publishStreamId) {
            antmedia.handleLeaveFromRoom();
        }
        msettings?.setLeftTheRoom(true);
        resetIncomingCall();
    }
    const openChat = () => {
        navigate(`/messages/${encodeRouteParam(vCallIncomingMessage.username)}`);
    }

    useEffect(() => {
        if (vCallIncomingMessage.roomId != undefined && vCallIncomingMessage.streamId !== null && !joinedRoom) {
            antmedia.joinRoom(roomName, vCallIncomingMessage.streamId, "mcu");
            startTimer();
        } else if (vCallIncomingMessage?.requesttype.toLowerCase().includes("LeaveRoom") && joinedRoom) {
            hangupVideoCall();
        }
    }, [vCallIncomingMessage]);



    console.log("allparticipants", allParticipants, audioTracks)
    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx(" draggable fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                !overlay && "hidden"
            )}>
            </div>
            <div
                ref={ref}
                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    isDragging && "bg-geyser",
                    !isDragging && "bg-white",
                    "draggable w-[400px] rounded-lg absolute shadow-sm bg-white z-[21] overflow-hidden min-h-[104px] p-[16px]"
                )}>

                <div className="flex flex-col justify-between items-center">
                    <div className="draggable bg-white rounded-lg text-md self-start flex flex-row">
                        <div className="draggable rounded-lg ml-[8px]">
                            <div className="draggable flex flex-col gap-[8px] items-start leading-4">
                                <span className="text-base text-grey-200 cursor-default">Audio Call {toHHMMSS(duration)}</span>
                                <span className="font-semibold text-black text-lg cursor-default">{msettings.customerName}</span>
                                <div className="flex flex-col gap-[8px]">
                                    {audioTracks.map((audio: any, index: number) => {
                                        //console.log("mic", audioTracks)
                                        const participant = allParticipants[index]
                                        console.log("participants satu2:", participant)
                                        const key = `key${index}`
                                        return (!audio.id.includes("agentStream") &&//participant &&
                                            <AudioCard
                                                key={key}
                                                onHandlePin={() => { }}
                                                id={audio.streamId}
                                                track={audio.track}
                                                autoPlay
                                                name={participant ? participant.streamName : ""}
                                            />

                                        )
                                    }
                                    )}
                                    <div id="meeting-gallery" >
                                        {(
                                            <>
                                                {LoadParticipants(participants, setPinRemoteVideo, setPinVideoId, pinVideoId)}
                                                {LoadLocalVideo(participants, pinRemoteVideo, setPinRemoteVideo, setPinVideoId, pinVideoId)}                                                <div className={clsx("draggable absolute p-[16px] top-[0px] right-[0px] flex flex-col items-center w-[160px]")}>
                                                    <div className={clsx("draggable rounded-md bg-white h-[52px] py-[8px] px-[16px] gap-[20px] flex flex-row justify-between ")}>

                                                        <div className="flex flex-row-reverse justify-end gap-[12px] items-center">
                                                            <Button shape="ellipse" onClick={hangupVideoCall} type="button" variant="contained" color="danger" iconButton className="w-[32px] h-[32px]">
                                                                <HangupIcon className="w-[20px] h-[20px] text-white" />
                                                            </Button>
                                                            <Button shape="ellipse" onClick={toggleMute} type="button" variant="contained" color={mic?.isMicMuted ? "primary" : "light"} iconButton className="w-[32px] h-[32px]">
                                                                {
                                                                    mic?.isMicMuted ?
                                                                        <MuteIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />
                                                                        : <UnmuteIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />

                                                                }
                                                            </Button>
                                                            <Button shape="ellipse" onClick={openChat} type="button" variant="contained" color={rightPanel === "chat" ? "primary" : "light"} iconButton className="w-[32px] h-[32px]">
                                                                <ChatIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>

    );
};

export default AudioCallControl;
